exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wAN2u{position:relative}._20geN{font-size:24px;font-weight:700}._3ogaN{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._2agIP{margin-bottom:20px}._3Yh2P{display:-webkit-box;display:-ms-flexbox;display:flex}._304SK{width:calc(33% - 20px)}._15uJv,._304SK{margin-right:20px;margin-bottom:20px}._15uJv{width:calc(50% - 10px)!important;-ms-flex-preferred-size:auto!important;flex-basis:auto!important}._1qxzH{margin-right:18px;width:calc(50% - 18px)!important}._304SK:last-of-type{margin-right:0}@media screen and (max-width:768px){._20geN{font-size:18px;margin:14px 0}}._2-zdu{font-size:17px;font-weight:700}.wAN2u a{text-decoration:none;color:#000}._2stqR{padding:15px 0 40px}.nEg7E{font-size:15px;text-align:end;color:#0074c2;display:block}", ""]);

// exports
exports.locals = {
	"root": "wAN2u",
	"title": "_20geN",
	"newsContainer": "_3ogaN",
	"primary": "_2agIP",
	"row": "_3Yh2P",
	"newsItem": "_304SK",
	"newsItem2Col": "_15uJv",
	"videoItem2Col": "_1qxzH",
	"videoTitle": "_2-zdu",
	"videoBLock": "_2stqR",
	"showAllTitle": "nEg7E"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/NewsBlock/NewsBlock.css
// module id = 2468
// module chunks = 32 33